import PlatformSelectWithCreate from './PlatformSelectWithCreate'

export default PlatformSelectWithCreate
